import React, { Component } from 'react';
import {
  AdminContainer, AdminSection as Section, Title, Form, InputGroup, AdminButton as Button, Message,
  TabContainer, Tab, CreateNavGrid
} from './partials';
import { api } from './api';

export class BusAdmin extends Component {
  state = {
    activeTab: 'event', // event, bus, person, family, reset
    message: null,
    error: false,
    // Form Data
    // Form Data
    eventId: '',
    eventName: '',
    // busId removed
    busName: '',
    busCapacity: '55',
    busType: 'ida',
    // personId removed
    personName: '',
    personLastNames: '',
    personNeed: 'ida',
    personFamily: '',
    // familyId removed
    familyName: '',
    resetBusId: '',
    resetBusesList: [],
    resetAssignments: {},
    resetPeople: [],
    loadingBuses: false,
    eventsList: [],
    loadingEvents: false,
    familiesList: [],
    loadingFamilies: false,
    expandedBusId: null,
    // Family Creation State
    peopleWithoutFamily: [],
    selectedFamilyMembers: [],
    adminMode: 'create' // 'create' or 'reset'
  };

  componentDidMount() {
    this.fetchEvents();
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleEventChange = (e) => {
    const newEventId = e.target.value;
    this.setState({ eventId: newEventId });
    if (newEventId) {
      this.fetchFamilies(newEventId);
      this.fetchPeopleWithoutFamily(newEventId);
    } else {
      this.setState({ familiesList: [], peopleWithoutFamily: [] });
    }
  };

  setAdminMode = (mode) => {
    this.setState({ adminMode: mode, message: null, error: false });
    if (mode === 'reset') {
      this.setTab('reset');
    } else {
      // Default to 'event' when switching back to create
      if (this.state.activeTab === 'reset') {
        this.setTab('event');
      }
    }
  }

  setTab = (tab) => {
    this.setState({ activeTab: tab, message: null, error: false });
    if (tab === 'family' && this.state.eventId) {
      this.fetchPeopleWithoutFamily(this.state.eventId);
    }
    if (tab === 'reset') {
      // Refresh events just in case
      this.fetchEvents();
      this.setState({ eventId: '', resetBusesList: [], resetAssignments: {}, resetPeople: [], expandedBusId: null });
    }
  };

  fetchEvents = async () => {
    try {
      this.setState({ loadingEvents: true });
      const events = await api.getEvents();
      this.setState({ eventsList: events, loadingEvents: false });
      // If we have an eventId already selected, make sure to fetch its families if needed
      if (this.state.eventId) {
        if (this.state.familiesList.length === 0) this.fetchFamilies(this.state.eventId);
        this.fetchPeopleWithoutFamily(this.state.eventId);
      }
    } catch (err) {
      this.setState({ loadingEvents: false });
      // console.error(err);
    }
  };

  fetchFamilies = async (eventId) => {
    try {
      this.setState({ loadingFamilies: true });
      const families = await api.getFamilies(eventId);
      this.setState({ familiesList: families, loadingFamilies: false });
    } catch (err) {
      this.setState({ loadingFamilies: false });
      console.error('Error fetching families', err);
    }
  };

  fetchPeopleWithoutFamily = async (eventId) => {
    try {
      const allPeople = await api.getPeople(eventId);
      // Filter people without family
      // IMPORTANT: Adjust property name based on DB/API response. Usually 'family' or 'familyId' is null.
      const withoutFamily = allPeople
        .filter(p => !p.family)
        .sort((a, b) => a.id - b.id); // Sort by ID (creation order approx)

      this.setState({ peopleWithoutFamily: withoutFamily, selectedFamilyMembers: [] });
    } catch (err) {
      console.error('Error fetching people without family', err);
    }
  };

  handleToggleFamilyMember = (personId) => {
    this.setState(prevState => {
      const selected = prevState.selectedFamilyMembers;
      if (selected.includes(personId)) {
        return { selectedFamilyMembers: selected.filter(id => id !== personId) };
      } else {
        return { selectedFamilyMembers: [...selected, personId] };
      }
    });
  };

  handleCreateEvent = async (e) => {
    e.preventDefault();
    const { eventName, eventId } = this.state;
    try {
      await api.createEvent(eventName, eventId);
      this.showMessage('Evento creado con éxito');
      this.setState({ eventName: '', eventId: '' });
      this.fetchEvents();
    } catch (err) {
      this.showMessage(err.message, true);
    }
  };

  handleCreateBus = async (e) => {
    e.preventDefault();
    const { busName, busCapacity, busType, eventId } = this.state;
    if (!eventId) return this.showMessage('Selecciona un evento primero', true);

    try {
      await api.createBus(busName, busCapacity, busType, eventId);
      this.showMessage('Autobús creado con éxito');
      this.setState({ busName: '', busCapacity: '55' });
    } catch (err) {
      this.showMessage(err.message, true);
    }
  };

  handleCreatePerson = async (e) => {
    e.preventDefault();
    const { personName, personLastNames, personNeed, personFamily, eventId } = this.state;
    if (!eventId) return this.showMessage('Selecciona un evento primero', true);

    try {
      await api.createPerson(personName, personLastNames, personNeed, personFamily, eventId);
      this.showMessage('Persona creada con éxito');
      this.setState({ personName: '', personLastNames: '', personNeed: 'ida', personFamily: '' });
      // Refresh people list for family selector
      this.fetchPeopleWithoutFamily(eventId);
    } catch (err) {
      this.showMessage(err.message, true);
    }
  };

  showMessage = (msg, isError = false) => {
    this.setState({ message: msg, error: isError });
    setTimeout(() => this.setState({ message: null, error: false }), 3000);
  };

  handleCreateFamily = async (e) => {
    e.preventDefault();
    const { familyName, eventId, selectedFamilyMembers } = this.state;

    if (selectedFamilyMembers.length === 0) {
      if (!window.confirm('No has seleccionado a nadie. ¿Crear familia vacía?')) return;
    }

    try {
      // No ID needed anymore, DB autoincrements
      await api.createFamily(familyName, eventId, selectedFamilyMembers);
      this.showMessage('Familia creada con éxito');
      this.setState({ familyName: '', selectedFamilyMembers: [] });
      // Refresh lists
      this.fetchFamilies(eventId);
      this.fetchPeopleWithoutFamily(eventId);
    } catch (err) {
      this.showMessage(err.message, true);
    }
  };

  componentWillUnmount() {
    this.stopPolling();
  }

  componentDidUpdate(prevProps, prevState) {
    // Start/Stop polling based on activeTab and eventId
    const isResetMode = this.state.activeTab === 'reset' && this.state.eventId;
    const wasResetMode = prevState.activeTab === 'reset' && prevState.eventId;

    if (isResetMode && !wasResetMode) {
      this.startPolling();
    } else if (!isResetMode && wasResetMode) {
      this.stopPolling();
    }
  }

  startPolling = () => {
    if (this.pollingInterval) return;
    this.pollingInterval = setInterval(() => {
      this.handleFetchBusesForReset(true); // true = background fetch
    }, 3000);
  };

  stopPolling = () => {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
  };

  handleFetchBusesForReset = async (isBackground = false) => {
    const { eventId } = this.state;
    if (!eventId) {
      if (!isBackground) this.showMessage('Introduce un ID de evento', true);
      return;
    }
    try {
      if (!isBackground) this.setState({ loadingBuses: true });

      // Fetch ALL data
      const data = await api.getData(eventId);

      this.setState({
        resetBusesList: data.buses,
        resetAssignments: data.assignments,
        resetPeople: data.people,
        loadingBuses: false
      });
    } catch (err) {
      if (!isBackground) this.setState({ loadingBuses: false });
      // Don't show error toast on background polling to avoid annoyance
      if (!isBackground) this.showMessage('Error cargando datos del evento: ' + err.message, true);
    }
  };

  handleDeleteBus = async (busId, busName) => {
    if (!window.confirm(`¿ESTÁS SEGURO? Vas a ELIMINAR DEFINITIVAMENTE el autobús "${busName}".\n\nEsto borrará el bus y todas sus asignaciones.\nEsta acción no se puede deshacer.`)) return;

    try {
      await api.deleteBus(busId);
      this.showMessage(`Autobús "${busName}" eliminado (y sus pasajeros liberados).`);
      this.handleFetchBusesForReset();
    } catch (err) {
      this.showMessage(err.message, true);
    }
  };

  handleResetBus = async (busId, busName) => {
    if (!window.confirm(`¿PELIGRO: Estás seguro de que quieres VACIAR el bus "${busName}" (ID: ${busId})?`)) return;

    try {
      await api.resetBus(busId);
      this.showMessage(`Autobús "${busName}" vaciado con éxito`);
      this.handleFetchBusesForReset();
    } catch (err) {
      this.showMessage(err.message, true);
    }
  };

  toggleExpandBus = (busId) => {
    this.setState(prevState => ({
      expandedBusId: prevState.expandedBusId === busId ? null : busId
    }));
  };

  handleRemoveIndividualAssignment = async (busId, personId, personName) => {
    if (!window.confirm(`¿Estás seguro de que quieres sacar a "${personName}" del bus?`)) return;

    // OPTIMISTIC UPDATE: Remove locally first
    this.setState(prevState => {
      const currentList = prevState.resetAssignments[busId] || [];
      return {
        resetAssignments: {
          ...prevState.resetAssignments,
          [busId]: currentList.filter(id => id !== personId)
        }
      };
    });

    try {
      await api.removeAssignment(busId, personId);
      this.showMessage(`"${personName}" ha sido sacado del bus.`);
      // Background refresh to sync true state
      this.handleFetchBusesForReset(true);
    } catch (err) {
      this.showMessage(err.message, true);
      // Revert if error (optional, but good practice - for now just fetch)
      this.handleFetchBusesForReset();
    }
  };

  render() {
    const { activeTab, adminMode, message, error, resetBusesList, loadingBuses, resetAssignments, resetPeople, expandedBusId } = this.state;

    return (
      <AdminContainer hasTopBar={false}>
        <Title>Admin Gestión Buses</Title>

        {message && <Message error={error}>{message}</Message>}

        {/* Top Level Navigation */}
        <TabContainer style={{ marginBottom: '1rem' }}>
          <Tab active={adminMode === 'create'} onClick={() => this.setAdminMode('create')} style={{ fontSize: '1.2rem', padding: '0.75rem 1.5rem' }}>
            ✨ CREAR
          </Tab>
          <Tab active={adminMode === 'reset'} onClick={() => this.setAdminMode('reset')} style={{ fontSize: '1.2rem', padding: '0.75rem 1.5rem' }}>
            🔥 RESETEAR
          </Tab>
        </TabContainer>

        {/* Sub Navigation for Create Mode */}
        {adminMode === 'create' && (
          <CreateNavGrid>
            <Tab active={activeTab === 'event'} onClick={() => this.setTab('event')}>Eventos</Tab>
            <Tab active={activeTab === 'bus'} onClick={() => this.setTab('bus')}>Autobuses</Tab>
            <Tab active={activeTab === 'person'} onClick={() => this.setTab('person')}>Personas</Tab>
            <Tab active={activeTab === 'family'} onClick={() => this.setTab('family')}>Familias</Tab>
          </CreateNavGrid>
        )}

        <Section>
          {/* Global Event ID Field for linkage context */}
          {adminMode === 'create' && activeTab !== 'event' && (
            <InputGroup style={{ marginBottom: '1.5rem', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '1rem' }}>
              <label>Selecciona el Evento:</label>
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <select
                  name="eventId"
                  value={this.state.eventId}
                  onChange={this.handleEventChange}
                  required
                >
                  <option value="">-- Seleccionar Evento --</option>
                  {this.state.eventsList.map(ev => (
                    <option key={ev.id} value={ev.id}>
                      {ev.name} ({ev.id})
                    </option>
                  ))}
                </select>
                {activeTab === 'reset' && (
                  <Button type="button" onClick={this.handleFetchBusesForReset} style={{ marginTop: 0, padding: '0.5rem' }}>
                    Cargar Buses
                  </Button>
                )}
              </div>
            </InputGroup>
          )}

          {activeTab === 'event' && (
            <Form onSubmit={this.handleCreateEvent}>
              <h3>Crear Evento</h3>
              <InputGroup>
                <label>ID Evento (Texto único)</label>
                <input name="eventId" type="text" placeholder="Ej: boda" value={this.state.eventId} onChange={this.handleChange} required />
              </InputGroup>
              <InputGroup>
                <label>Nombre Evento</label>
                <input name="eventName" placeholder="Ej: Boda 2025" value={this.state.eventName} onChange={this.handleChange} required />
              </InputGroup>
              <Button type="submit">Crear Evento</Button>
            </Form>
          )}

          {activeTab === 'bus' && (
            <Form onSubmit={this.handleCreateBus}>
              <h3>Crear Autobús</h3>
              {/* Bus ID is now AUTO_INCREMENT */}
              <InputGroup>
                <label>Nombre</label>
                <input name="busName" placeholder="Ej: Bus 1 - Ida" value={this.state.busName} onChange={this.handleChange} required />
              </InputGroup>
              <InputGroup>
                <label>Capacidad</label>
                <input name="busCapacity" type="number" value={this.state.busCapacity} onChange={this.handleChange} required />
              </InputGroup>
              <InputGroup>
                <label>Tipo</label>
                <select name="busType" value={this.state.busType} onChange={this.handleChange}>
                  <option value="ida">Ida</option>
                  <option value="vuelta">Vuelta</option>
                  <option value="ambas">Ambas</option>
                </select>
              </InputGroup>
              <Button type="submit">Crear Autobús</Button>
            </Form>
          )}

          {activeTab === 'family' && (
            <Form onSubmit={this.handleCreateFamily}>
              <h3>Crear Familia</h3>
              {/* Family ID is now AUTO_INCREMENT */}

              <InputGroup>
                <label>Nombre Familia</label>
                <input name="familyName" placeholder="Ej: Familia Perez" value={this.state.familyName} onChange={this.handleChange} required />
              </InputGroup>

              <div style={{ marginTop: '1rem' }}>
                <label style={{ color: 'var(--primary)', fontWeight: 'bold' }}>Seleccionar Integrantes (Sin familia actual):</label>

                <div style={{
                  maxHeight: '300px',
                  overflowY: 'auto',
                  background: 'rgba(0,0,0,0.2)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '6px',
                  padding: '0.5rem',
                  marginTop: '0.5rem'
                }}>
                  {this.state.peopleWithoutFamily.length === 0 && (
                    <div style={{ padding: '0.5rem', opacity: 0.7 }}>No hay personas sin familia para asignar.</div>
                  )}

                  {this.state.peopleWithoutFamily.map(p => (
                    <div key={p.id} style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.75rem',
                      padding: '0.5rem',
                      borderBottom: '1px solid rgba(255,255,255,0.05)'
                    }}>
                      <input
                        type="checkbox"
                        checked={this.state.selectedFamilyMembers.includes(p.id)}
                        onChange={() => this.handleToggleFamilyMember(p.id)}
                        style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                      />
                      <div>
                        <div style={{ fontWeight: 'bold' }}>{p.name} {p.lastNames}</div>
                        <div style={{ fontSize: '0.8rem', opacity: 0.7 }}>ID: {p.id} | {p.need}</div>
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ fontSize: '0.8rem', marginTop: '0.5rem', opacity: 0.8 }}>
                  {this.state.selectedFamilyMembers.length} personas seleccionadas
                </div>
              </div>

              <Button type="submit">Crear Familia con Seleccionados</Button>
            </Form>
          )}

          {activeTab === 'person' && (
            <Form onSubmit={this.handleCreatePerson}>
              <h3>Crear Persona</h3>
              {/* Person ID is now AUTO_INCREMENT */}

              <InputGroup>
                <label>Nombre</label>
                <input name="personName" value={this.state.personName} onChange={this.handleChange} required />
              </InputGroup>
              <InputGroup>
                <label>Apellidos</label>
                <input name="personLastNames" value={this.state.personLastNames} onChange={this.handleChange} />
              </InputGroup>
              <InputGroup>
                <label>Necesidad</label>
                <select name="personNeed" value={this.state.personNeed} onChange={this.handleChange}>
                  <option value="ida">Ida</option>
                  <option value="vuelta">Vuelta</option>
                  <option value="ambas">Ambas</option>
                </select>
              </InputGroup>
              <InputGroup>
                <label>Familia (Opcional)</label>
                <select name="personFamily" value={this.state.personFamily} onChange={this.handleChange}>
                  <option value="">-- Ninguna / Individual --</option>
                  {this.state.familiesList.map(fam => (
                    <option key={fam.id} value={fam.id}>
                      {fam.name} ({fam.id})
                    </option>
                  ))}
                </select>
              </InputGroup>
              <Button type="submit">Crear Persona</Button>
            </Form>
          )}

          {activeTab === 'reset' && (
            <div>
              <h3 style={{ color: '#e74c3c' }}>Zona de Peligro: Resetear Bus</h3>

              {!this.state.eventId && (
                <div style={{ marginBottom: '2rem' }}>
                  <p style={{ fontSize: '0.9rem', marginBottom: '1rem', opacity: 0.8 }}>
                    Selecciona un evento para ver sus autobuses:
                  </p>

                  {this.state.loadingEvents && <div>Cargando eventos...</div>}

                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.75rem' }}>
                    {this.state.eventsList && this.state.eventsList.map(ev => (
                      <button
                        key={ev.id}
                        onClick={() => {
                          this.setState({ eventId: ev.id }, this.handleFetchBusesForReset);
                        }}
                        style={{
                          background: 'rgba(255,255,255,0.1)',
                          border: '1px solid var(--primary)',
                          color: 'var(--text)',
                          padding: '0.75rem 1.2rem',
                          borderRadius: '20px',
                          cursor: 'pointer',
                          fontSize: '0.9rem'
                        }}
                      >
                        <strong>{ev.name}</strong> ({ev.id})
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {this.state.eventId && (
                <div style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'rgba(52, 152, 219, 0.2)', padding: '0.75rem', borderRadius: '8px' }}>
                  <div>
                    Estás gestionando el evento: <strong>{this.state.eventId}</strong>
                  </div>
                  <button
                    onClick={() => this.setState({ eventId: '', resetBusesList: [], resetAssignments: {} })}
                    style={{ background: 'transparent', border: '1px solid #fff', color: '#fff', padding: '0.25rem 0.75rem', borderRadius: '4px', cursor: 'pointer', fontSize: '0.8rem' }}
                  >
                    Cambiar
                  </button>
                </div>
              )}

              {this.state.eventId && (
                <>
                  <p style={{ fontSize: '0.9rem', marginBottom: '1rem', opacity: 0.8 }}>
                    Gestiona los pasajeros de cada autobús. Puedes vaciar el bus entero o sacar pasajeros individualmente.
                  </p>

                  {loadingBuses && <div>Cargando autobuses y pasajeros...</div>}

                  {!loadingBuses && resetBusesList && resetBusesList.length === 0 && (
                    <div>No se encontraron autobuses para este evento.</div>
                  )}

                  <div style={{ display: 'grid', gap: '1rem' }}>
                    {resetBusesList && resetBusesList.map(bus => {
                      const assignments = resetAssignments[bus.id] || [];
                      const count = assignments.length;
                      const isExpanded = expandedBusId === bus.id;

                      return (
                        <div key={bus.id} style={{
                          background: 'rgba(255,255,255,0.05)',
                          borderRadius: '8px',
                          border: '1px solid rgba(255,255,255,0.1)',
                          overflow: 'hidden'
                        }}>
                          <div style={{
                            padding: '1rem',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            background: isExpanded ? 'rgba(255,255,255,0.05)' : 'transparent'
                          }}>
                            <div style={{ flex: 1 }}>
                              <div style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>{bus.name}</div>
                              <div style={{ fontSize: '0.85rem', opacity: 0.7, marginTop: '0.25rem' }}>
                                Pasajeros: <strong>{count}</strong> / {bus.capacity}
                              </div>
                            </div>

                            <div style={{ display: 'flex', gap: '0.5rem' }}>
                              <Button
                                type="button"
                                onClick={() => this.toggleExpandBus(bus.id)}
                                style={{ marginTop: 0, padding: '0.5rem 1rem', background: '#3498db' }}
                              >
                                {isExpanded ? 'Ocultar' : 'Ver Gente'}
                              </Button>

                              <Button
                                className="danger"
                                onClick={() => this.handleResetBus(bus.id, bus.name)}
                                style={{ marginTop: 0, padding: '0.5rem 1rem' }}
                                disabled={count === 0}
                              >
                                VACIAR TODO
                              </Button>

                              <Button
                                onClick={() => this.handleDeleteBus(bus.id, bus.name)}
                                style={{ marginTop: 0, padding: '0.5rem 1rem', background: '#000', color: '#fff', border: '1px solid #444' }}
                              >
                                ELIMINAR BUS
                              </Button>
                            </div>
                          </div>

                          {/* Expanded List */}
                          {isExpanded && (
                            <div style={{ padding: '1rem', background: 'rgba(0,0,0,0.2)' }}>
                              {count === 0 ? (
                                <div style={{ opacity: 0.6, fontStyle: 'italic' }}>El autobús está vacío.</div>
                              ) : (
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '0.5rem' }}>
                                  {assignments.map(personId => {
                                    const p = resetPeople.find(rp => rp.id === personId);
                                    if (!p) return null;
                                    return (
                                      <div key={personId} style={{
                                        padding: '0.5rem',
                                        background: 'rgba(255,255,255,0.05)',
                                        borderRadius: '4px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        fontSize: '0.9rem'
                                      }}>
                                        <span>{p.name} {p.lastNames}</span>
                                        <button
                                          onClick={() => this.handleRemoveIndividualAssignment(bus.id, personId, p.name)}
                                          style={{
                                            background: '#e74c3c',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '50%',
                                            width: '24px',
                                            height: '24px',
                                            cursor: 'pointer',
                                            marginLeft: '0.5rem',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontWeight: 'bold'
                                          }}
                                          title="Sacar del bus"
                                        >
                                          ×
                                        </button>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          )}

        </Section>
      </AdminContainer>
    );
  }
}
